import { render, staticRenderFns } from "./TopNavItems.vue?vue&type=template&id=2638f4a0"
import script from "./TopNavItems.vue?vue&type=script&lang=js"
export * from "./TopNavItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports